import { Directive, Input, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[middleClick], [routerLink]',
  standalone: true,
})
export class MiddleClickDirective {
  private router = inject(Router);
  @Input() middleClick?: string;
  @Input() routerLink?: string | any[];

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (event.button !== 1) return;

    let targetUrl: string | undefined;

    if (this.middleClick) {
      targetUrl = this.middleClick;
    } else if (this.routerLink) {
      const urlTree = this.router.createUrlTree(
        Array.isArray(this.routerLink) ? this.routerLink : [this.routerLink]
      );
      targetUrl = this.router.serializeUrl(urlTree);
    }

    if (targetUrl) {
      if (targetUrl.startsWith('/')) {
        window.open(targetUrl, '_blank');
      } else {
        window.open(targetUrl, '_blank');
      }

      event.preventDefault();
      event.stopPropagation();
    }
  }
}
